module.exports = __webpack_public_path__ + "img/qty-sale.2a089f84.svg";